import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import * as RootState from '@cde-fe-app/app/shared/state';
import { featureToggleStore } from '@cde-fe-app/app/shared/state/feature-toggle/feature-toggle.store';
import * as OrganisationsState from '@cde-fe-app/app/shared/state/organisations';
import { replaceOrUpdateQueryParam } from '@cde-fe-app/app/shared/utils/append-or-replace-orgId-param';
import { AppLauncherAppTileComponent } from './app-launcher-app-tile/app-launcher-app-tile.component';
import { appLauncherAppDescriptions } from './app-launcher.source';

@Component({
  selector: 'app-app-launcher',
  templateUrl: './app-launcher.component.html',
  styleUrls: ['./app-launcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppLauncherAppTileComponent, TranslateModule],
})
export class AppLauncherComponent {
  readonly store = inject<Store<RootState.IState>>(Store<RootState.IState>);
  readonly cdRef = inject(ChangeDetectorRef);
  readonly translator = inject(TranslateService);
  readonly featureToggleStore = inject(featureToggleStore);

  public appDescriptions$$ = this.initializeAppDescriptions();

  private currentOrganisation$$ = toSignal(this.store.select(OrganisationsState.getCurrentOrganisation));

  initializeAppDescriptions() {
    return computed(() => {
      const currentOrganisation = this.currentOrganisation$$();
      const featureToggles = this.featureToggleStore.featureToggles();

      if (
        currentOrganisation == null ||
        !currentOrganisation.auth0Id ||
        !featureToggles ||
        featureToggles.length === 0
      ) {
        return;
      }

      return appLauncherAppDescriptions.map(desc => {
        const appDescription = { ...desc };
        if (appDescription.appendOrgId) {
          appDescription.link = replaceOrUpdateQueryParam('orgId', currentOrganisation.auth0Id, appDescription.link);
        }

        // Handle appLauncherFastAccess links
        if (appDescription.appLauncerFastAccess) {
          appDescription.appLauncerFastAccess.forEach(fastAccessDescription => {
            if (fastAccessDescription.appendOrgId) {
              fastAccessDescription.link = replaceOrUpdateQueryParam(
                'orgId',
                currentOrganisation.auth0Id,
                fastAccessDescription.link
              );
            }
          });
        }

        return appDescription;
      });
    });
  }
}
